export function getListingForWorker(data) {
    return new Promise((resolve, reject) => {
		let { getListingForWorkerRequest, getListingForWorkerError, getListingForWorkerResult } = this.props;

		this.doAction(
			this.WEB_REQUEST_URL + 'get_listing_worker_list',
			this.createBundle(
				'get_listing_worker_list',
				{ worker: data },
				this.GET,
				getListingForWorkerRequest,
                (result) => {
                    getListingForWorkerResult(result)
                    resolve(result)
                },
                (error) => {
                    getListingForWorkerError(error)
                    reject(error)
                }
			)
		);
	})
}
